/**
 * Отложенная загрузка стилей и скриптов для библиотеки сделана по аналогии с модулем slidersLibrary
 * Поэтому здесь нет поясняющих комментариев
 */
itsoftApp.createModule("fancyBox", function () {
    var module = this;
    var queue = [];
    var libraryLoaded = false;
    var loadingStarted = false;
    var initQueue = function () {
        if (!libraryLoaded) {
            return false;
        }
        var qLen = queue.length;
        if (!qLen) {
            return;
        }
        DEBUG && console.log("[module fancyBox] initQueue function fired, queue.length: " + qLen);
        while (queue.length > 0) {
            queue.shift()();
        }
    };
    var loadAndInit = function () {
        var f = function () {
            libraryLoaded = true;
            initQueue();
        };
        itsoftApp.loadStyle("/assets/scripts/fancybox/fancybox.css");
        itsoftApp.loadScript("/assets/scripts/fancybox/fancybox.umd.js", function () {
            DEBUG && console.log("[module fancyBox] library loaded, ready to init queue");
            f();
        });
    };
    var addEvent = function (func) {
        if (typeof func !== "function") {
            return;
        }
        if (!libraryLoaded) {
            if (!loadingStarted) {
                console.log("loadLibray")
                loadingStarted = true;
                DEBUG && console.log("%c--[module fancyBox] first function added. delegating loadAndInit to pageLoad module (or firing if page already loaded)", "font-style: italic; color: #999");
                itsoftApp.modules.pageLoad.addEvent(loadAndInit);
            }
            queue.push(func);
            DEBUG && console.log("[module fancyBox] function added, count of functions to init now: " + queue.length);
        } else {
            func();
        }
    };
    var setFancyBox = function() {
        console.log("setFancybox")
        var createFancyBox = function() {
            console.log("createFancybox")
            Fancybox.bind('.popup-custom-trigger[data-fancybox]', {
                mainClass: 'js-custom-popup',
                Toolbar: false,
                click: false,
                dragToClose: false,
                autoFocus: false,
                groupAttr: false,
                Image: {
                    zoom: false,
                    wheel: false,
                    click: false,
                },
            });
        }
        addEvent(createFancyBox);
    }
    module.addEvent = addEvent;
    module.callback = setFancyBox;
});